import React, { useEffect, useRef } from "react";

const PhoneEmailSignIn = ({ clientId, onVerificationSuccess }) => {
  const containerRef = useRef(null);
  const scriptLoadedRef = useRef(false);
  const callbackRef = useRef(onVerificationSuccess);

  // Update callback ref when prop changes
  useEffect(() => {
    callbackRef.current = onVerificationSuccess;
  }, [onVerificationSuccess]);

  useEffect(() => {
    // Set up the listener function immediately (before script loads)
    // This ensures it's available when the script tries to call it
    if (typeof window !== "undefined") {
      window.phoneEmailListener = function (userObj) {
        const { user_json_url } = userObj;
        if (callbackRef.current) {
          callbackRef.current(user_json_url);
        }
      };
    }

    // Only load script once
    if (scriptLoadedRef.current) {
      return;
    }

    // Check if script already exists
    const existingScript = document.querySelector(
      'script[src="https://www.phone.email/sign_in_button_v1.js"]'
    );
    if (existingScript) {
      scriptLoadedRef.current = true;
      return;
    }

    // Create and load the script
    const script = document.createElement("script");
    script.src = "https://www.phone.email/sign_in_button_v1.js";
    script.async = true;
    script.onload = () => {
      scriptLoadedRef.current = true;
    };
    script.onerror = () => {
      console.error("Failed to load phone.email script");
    };
    document.body.appendChild(script);

    // Don't remove listener on cleanup - it needs to persist
    // The listener will be updated with the latest callback via callbackRef
    return () => {
      // Keep the listener but update it to use the latest callback
      if (typeof window !== "undefined" && window.phoneEmailListener) {
        window.phoneEmailListener = function (userObj) {
          const { user_json_url } = userObj;
          if (callbackRef.current) {
            callbackRef.current(user_json_url);
          }
        };
      }
    };
  }, []); // Empty dependency array - only run once

  return (
    <div
      className="pe_signin_button"
      data-client-id={clientId}
      ref={containerRef}
    ></div>
  );
};

export default PhoneEmailSignIn;
